import { T } from "@supersig/validate";
import { resourceIdValidator } from "../../swschema/resources/SWBaseResource";
export const swFontResourceReference = T.object({
    resourceId: resourceIdValidator,
    version: T.number
});
export const swTextResourceReference = T.object({
    resourceId: resourceIdValidator,
    version: T.number
});
